$(function() {
  $(document).foundation();
});
